import { GridColumn } from 'types/grid';
import { ModalListData } from 'types/modal';
import { ListType } from 'types/selectbox';

/**
  export const manageGridColumns: GridColumn[] = [
  { title: 'Name', key: 'name', width: 200 },
  { title: 'Norad ID', key: 'noradId', width: 120 },
  { title: 'TLE - Title Line', key: 'tleTitle', width: 180 },
  { title: 'Direction', key: 'direction', width: 120 },
  { title: 'Band', key: 'bandName', width: 120 },
  { title: 'CenterFrequency', key: 'centerFrequency', width: 160 },
  { title: 'Registered At', key: 'createdDate', width: 260 },
  { title: 'TLE Update', key: 'update', width: 130 },
  { title: '', key: 'viewDetails' },
];
 */
export const manageGridColumns: GridColumn[] = [
  { title: 'manage.grid.name', key: 'name', width: 190 ,showOnMobile: true},
  { title: 'manage.grid.noradId', key: 'noradId', width: 120 ,showOnMobile: false},
  { title: 'manage.grid.tleTitle', key: 'tleTitle', width: 180, showOnMobile: false },
  { title: 'manage.grid.direction', key: 'direction', width: 120, showOnMobile: false },
  { title: 'manage.grid.band', key: 'bandName', width: 120, showOnMobile: false },
  // { title: 'manage.grid.centerFrequency', key: 'centerFrequency', width: 160, showOnMobile: false },
  { title: 'manage.grid.registeredAt', key: 'createdDate', width: 260, showOnMobile: false },
  { title: 'manage.grid.tleUpdate', key: 'update', width: 120, showOnMobile: true },
  { title: '', key: 'viewDetails', showOnMobile: true },
];

/*
export const manageModalList: ModalListData[] = [
  { title: 'Name', key: 'name' },
  { title: 'NORAD ID', key: 'noradId' },
  { title: 'TLE - Title', key: 'tleTitle' },
  { title: 'TLE - Line 1', key: 'tleFirst' },
  { title: 'TLE - Line 2', key: 'tleSecond'},
  { title: 'Direction', key: 'direction' },
  { title: 'Band', key: 'band'},
  { title: 'Center frequency (MHz)', key: 'centerFrequency' },
  { title: 'Modulation', key: 'modulationName' },
  { title: 'Bit Rate', key: 'bitRate' },
  { title: 'Polarization', key: 'polarizationName' },
  { title: 'Convolutional Code or Derandomization', key: 'convolutionalCodeName'},
  { title: 'Reed-Solomon Code(FEC)', key: 'rsCodeName'},
  { title: 'Subcarrier Frequency', key: 'subFrequency'},
  { title: 'PCM Coding', key: 'pcmCodingName'},
  { title: 'Frame Sync Word', key: 'frameSyncWord'},
  { title: 'Frame Size', key: 'frameSize'},
  { title: 'SYN', key: 'syn'},
  { title: 'CTL', key: 'ctl'},
  { title: 'LTS', key: 'lts'},
  { title: 'SLIP', key: 'slip'},
  { title: '(Optional) Other', key: 'other'},
];
*/
export const manageModalDetailListDownlink: ModalListData[] = [
  { title: 'manage.modal.detail.name', key: 'name' },
  { title: 'manage.modal.detail.noradId', key: 'noradId' },
  { title: 'manage.modal.detail.tleTitle', key: 'tleTitle' },
  { title: 'manage.modal.detail.tleLine1', key: 'tleFirst' },
  { title: 'manage.modal.detail.tleLine2', key: 'tleSecond' },
  { title: 'manage.modal.detail.direction', key: 'direction' },
  { title: 'manage.modal.detail.band', key: 'band' },
  { title: 'manage.modal.detail.centerFrequency', key: 'centerFrequency' },
  { title: 'manage.modal.detail.modulationName', key: 'modulationName' },
  { title: 'manage.modal.detail.bitRate', key: 'bitRate' },
  { title: 'manage.modal.detail.polarizationName', key: 'polarizationName' },
  { title: 'manage.modal.detail.convolutionalCodeName', key: 'convolutionalCodeName' },
  { title: 'manage.modal.detail.rsCodeName', key: 'rsCodeName' },
  { title: 'manage.modal.detail.subFrequency', key: 'subFrequency' },
  { title: 'manage.modal.detail.pcmCodingName', key: 'pcmCodingName' },
  { title: 'manage.modal.detail.frameSyncWord', key: 'frameSyncWord' },
  { title: 'manage.modal.detail.frameSize', key: 'frameSize' },
  { title: 'manage.modal.detail.syn', key: 'syn' },
  { title: 'manage.modal.detail.ctl', key: 'ctl' },
  { title: 'manage.modal.detail.lts', key: 'lts' },
  { title: 'manage.modal.detail.slip', key: 'slip' },
  { title: 'manage.modal.detail.other', key: 'other' }
];

export const manageModalDetailListUplink: ModalListData[] = [
  { title: 'manage.modal.detail.name', key: 'name' },
  { title: 'manage.modal.detail.noradId', key: 'noradId' },
  { title: 'manage.modal.detail.tleTitle', key: 'tleTitle' },
  { title: 'manage.modal.detail.tleLine1', key: 'tleFirst' },
  { title: 'manage.modal.detail.tleLine2', key: 'tleSecond' },
  { title: 'manage.modal.detail.direction', key: 'direction' },
  { title: 'manage.modal.detail.band', key: 'band' },
  { title: 'Polarization', key: 'polarizationName' },
  { title: 'manage.modal.detail.bitRate', key: 'bitRate' },
  { title: 'PCM Code', key: 'pcmCode' },
  { title: 'Idle Pattern', key: 'idlePattern' },
  { title: 'Idle Pattern Length', key: 'idlePatternLength' },
  { title: 'Preamble Length', key: 'preambleLength' },
  { title: 'Carrier Frequency (MHz)', key: 'carrierFrequencyMhz' },
  { title: 'Operating Mode', key: 'operatingMode' },
  { title: 'IF Carrier Level (dB)', key: 'ifCarrierLevel' },
  { title: 'Sweep Rate', key: 'sweepRate' },
  { title: 'Sweep Range', key: 'sweepRange' },
  { title: '(Optional) Other', key: 'other' },
];


export const registerPolarizationList: ListType[] = [
  { value: 0, label: 'LHCP' },
  { value: 1, label: 'RHCP' },
  { value: 2, label: 'BOTH' }
];

export const registerDirectionList: ListType[] = [
  {value:0, label: 'DOWNLINK'},
  {value:1, label: 'UPLINK'},
];
export const registerBandList: ListType[] = [
  {value:0, label: 'S_BAND'},
  {value:1, label: 'X_BAND'},
];

export const registerModulationList: ListType[] = [
  { value: 1, label: 'PCM/PM' },
  { value: 0, label: 'BPSK' },
  { value: 2, label: 'QPSK' }
];
export const reedSolomonCodeList: ListType[] = [
  { value: 0, label: 'None' },
  { value: 1, label: 'Rs Decoding (255, 223) Beta' },
];
export const registerPCMCodingList: ListType[] = [
  { value: 1, label: 'NRZ-L' },
  { value: 2, label: 'NRZ-M' },
  { value: 3, label: 'NRZ-S' },
  { value: 0, label: 'BP-L' },
  { value: 4, label: 'BP-M' },
  { value: 5, label: 'BP-S' },
];
export const registerConvolutionalCodeList: ListType[] = [
  { value: 0, label: 'None' },
  { value: 1, label: 'Derandomization'},
  { value: 2, label: 'Convolutional Inverted'},
  { value: 3, label: 'Convolutional'},
  { value: 4, label: 'Convolutional Inverted + Derandomization'},
  { value: 5, label: 'Convolutional + Derandomization'},
];

// Uplink 전용 리스트 (SelectBox 호환: 숫자 값 사용, 라벨은 문자열)
export const registerUplinkPCMCodeList: ListType[] = [
  { value: 0, label: 'NRZ-L' },
  { value: 1, label: 'NRZ-M' },
  { value: 2, label: 'BP-L' },
  { value: 3, label: 'RZ' },
  { value: 4, label: 'LRZ-S' },
  { value: 5, label: 'BP-M' },
  { value: 6, label: 'BP-S' },
];

export const registerOperatingModeList: ListType[] = [
  { value: 0, label: 'FM' },
  { value: 1, label: 'PM' },
  { value: 2, label: 'BPSK' },
  { value: 3, label: 'QPSK' },
  { value: 4, label: 'OQPSK' },
];

/*
// 컨펌 라벨
export const registerSpaceCraftList: ModalListData[] = [
  { title: 'Name', key: 'name' },  
  { title: 'NORAD ID', key: 'noradId' },
  { title: 'TLE - Title', key: 'tleTitle' }, 
  { title: 'TLE - Line 1', key: 'tleFirst' },
  { title: 'TLE - Line 2', key: 'tleSecond' },
  { title: 'Direction', key: 'directionName' },
  { title: 'DirectionId', key: 'linkDirection' },
  { title: 'Band', key: 'bandName' },
  { title: 'BandId', key: 'band' },
  { title: 'Center Frequency (MHz)', key: 'centerFrequency' },
  { title: 'modulationId', key: 'modulation' },
  { title: 'Modulation', key: 'modulationName' },
  { title: 'Bit Rate', key: 'bitRate' },
  { title: 'PolarizationId', key: 'polarization' },
  { title: 'Polarization', key: 'polarizationName' },
  { title: 'convolutionalCodeId', key: 'convolutionalCode' },
  { title: 'Convolutional Code or Derandomization', key: 'convolutionalCodeName' },
  { title: 'Reed-Solomon Code(FEC) Id', key: 'reedSolomonCode' },
  { title: 'Reed-Solomon Code(FEC)', key: 'reedSolomonCodeName' },
  { title: 'Randomization', key: 'randomizationName' },
  { title: 'RandomizationId', key: 'randomization' },
  { title: 'Subcarrier Frequency', key: 'subcarrierFrequency' },
  { title: 'PCM Coding Id', key: 'pcmCoding' },
  { title: 'PCM Coding', key: 'pcmCodingName' },
  { title: 'Frame Sync Word', key: 'framesyncword' },
  { title: 'Frame Size', key: 'framesize' },
  { title: 'SYN', key: 'syn' },
  { title: 'CTL', key: 'ctl' },
  { title: 'LTS', key: 'lts' },
  { title: 'SLIP', key: 'slip' },
  { title: '(Optional) Other', key: 'other' },
];
*/

export const registerSpaceCraftList: ModalListData[] = [
  { title: 'manage.modal.name', key: 'name' },
  { title: 'manage.modal.noradId', key: 'noradId' },
  { title: 'manage.modal.tleTitle', key: 'tleTitle' },
  { title: 'manage.modal.tleLine1', key: 'tleFirst' },
  { title: 'manage.modal.tleLine2', key: 'tleSecond' },
  { title: 'manage.modal.direction', key: 'directionName' },
  { title: 'manage.modal.directionId', key: 'linkDirection' },
  { title: 'manage.modal.band', key: 'bandName' },
  { title: 'manage.modal.bandId', key: 'band' },
  { title: 'manage.modal.centerFrequency', key: 'centerFrequency' },
  { title: 'manage.modal.modulationId', key: 'modulation' },
  { title: 'manage.modal.modulation', key: 'modulationName' },
  { title: 'manage.modal.bitRate', key: 'bitRate' },
  { title: 'manage.modal.polarizationId', key: 'polarization' },
  { title: 'manage.modal.polarization', key: 'polarizationName' },
  { title: 'manage.modal.convCodeId', key: 'convolutionalCode' },
  { title: 'manage.modal.convCode', key: 'convolutionalCodeName' },
  { title: 'manage.modal.rsCodeId', key: 'reedSolomonCode' },
  { title: 'manage.modal.rsCode', key: 'reedSolomonCodeName' },
  { title: 'manage.modal.randomization', key: 'randomizationName' },
  { title: 'manage.modal.randomizationId', key: 'randomization' },
  { title: 'manage.modal.subFrequency', key: 'subcarrierFrequency' },
  { title: 'manage.modal.pcmCodingId', key: 'pcmCoding' },
  { title: 'manage.modal.pcmCoding', key: 'pcmCodingName' },
  { title: 'manage.modal.frameSyncWord', key: 'framesyncword' },
  { title: 'manage.modal.frameSize', key: 'framesize' },
  { title: 'manage.modal.syn', key: 'syn' },
  { title: 'manage.modal.ctl', key: 'ctl' },
  { title: 'manage.modal.lts', key: 'lts' },
  { title: 'manage.modal.slip', key: 'slip' },
  { title: 'manage.modal.other', key: 'other' }
];

